export default __webpack_public_path__ + "static/media/single-project-page-03-img08.9eaf3063.jpg";